
(function ($) {
    const templateString = '<div class="popover M-popover" role="tooltip"><div class="d-flex justify-content-between"><h3 class="popover-header M-popover__header"></h3><div class="M-popover__close js-popover__close ml-auto"><img src="/src/images/basic/close.svg" alt="close"></div></div><div class="popover-body M-popover__body"></div></div>';
    $.nette.ext('bs-popover', {
        init() {
            const self = this;

            this.ext('snippets', true).after($.proxy(($el) => {
                self.init($el);
            }, this));

            self.init($('body'));

            $(document).on('click', '.js-popover__close', () => {
                $('.popover').popover('hide');
            });
            $('body').on('click', (e) => {
                $('[data-toggle=popover]').each(function () {
                    // hide any open popovers when the anywhere else in the body is clicked
                    if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                        $(this).popover('hide');
                    }
                });
            });
        },
    }, {
        init($el) {
            $($el).find("[data-toggle='popover']").each((index, element) => {
                const target = $(element).data().target;
                if (target) {
                    $(element).popover({
                        content: $(target).html(),
                        template: templateString,
                    });
                } else {
                    $(element).popover({
                        template: templateString,
                    });
                }
            });
            $($el).find('[data-toggle="popover"]').on('inserted.bs.popover', () => {
                // @todo workaround to fix confirmation links
                Bingo.Bootstrap.Confirmation.init($('.popover'));
                // @todo workaround to fix ajax links
                $('.popover a.ajax').on('click', function (e) {
                    e.preventDefault();
                    $.nette.ajax({
                        type: 'GET',
                        url: $(this).attr('href'),
                        success: () => {
                            $('.popover').popover('hide');
                        },
                    });
                });
            });
            $($el).find('[data-toggle="popover"]').on('hidden.bs.popover', function () {
                $(this).attr('title', $(this).attr('data-original-title'));
            });
        },
    });
}(jQuery));
